import { NewsAction, NewsActionTypes, NewsState } from 'store/types/news'

const initialState: NewsState = {
  news: [],
  newsTotal: 0,
  item: null,
  loading: false,
  error: null,
}

export const newsReducer = (
  state = initialState,
  action: NewsAction
): NewsState => {
  switch (action.type) {
    case NewsActionTypes.FETCH_NEWS:
      return {
        loading: true,
        error: null,
        item: null,
        news: state.news,
        newsTotal: state.newsTotal,
      }
    case NewsActionTypes.FETCH_NEWS_SUCCESS:
      return {
        loading: false,
        error: null,
        item: null,
        news: action.payload.items,
        newsTotal: action.payload.total,
      }
    case NewsActionTypes.FETCH_NEWS_SUCCESS_MORE:
      return {
        loading: false,
        error: null,
        item: null,
        news: [...state.news, ...action.payload.items],
        newsTotal: action.payload.total,
      }
    case NewsActionTypes.FETCH_NEWS_ERROR:
      return {
        loading: false,
        error: action.payload,
        news: [],
        newsTotal: 0,
        item: null,
      }
    case NewsActionTypes.FETCH_ITEM_NEWS:
      return { loading: true, error: null, news: [], newsTotal: 0, item: null }
    case NewsActionTypes.FETCH_ITEM_NEWS_SUCCESS:
      return {
        loading: false,
        error: null,
        news: [],
        newsTotal: 0,
        item: action.payload,
      }
    default:
      return state
  }
}
